'use strict';
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var General = require("./styles/General");
var Mixins = require("./styles/Mixins");
var Functions = require("./styles/Functions");
var General_1 = require("./styles/General");
exports.app = __assign({}, General.base, { position: 'absolute', maxWidth: '100vw', maxHeight: '100vh', minWidth: '400px', minHeight: '400px', padding: '2vmin' });
exports.newGameButton = {
    base: __assign({}, General.base, General.buttonBase, General.headerBtnBase),
    ':hover': __assign({}, General.buttonHoverBase),
    ':active': __assign({}, General.buttonActiveBase),
    ':focus': __assign({}, General.buttonFocusBase),
};
exports.resetGameButton = {
    base: __assign({}, General.base, General.buttonBase, General.headerBtnBase, { marginLeft: General.baseFontSize + "px" }),
    ':hover': __assign({}, General.buttonHoverBase),
    ':active': __assign({}, General.buttonActiveBase),
    ':focus': __assign({}, General.buttonFocusBase),
};
exports.githubLink = __assign({}, General.base, { float: 'right' });
var menuHeight = Functions.calcMenuHeight(exports.newGameButton.base);
exports.menu = __assign({}, General.base, { position: 'relative', width: '100%', height: menuHeight + "px", overflow: 'auto' });
exports.setup = __assign({}, General.base, { position: 'relative', width: '100%', height: '100%' });
exports.difficultySelect = __assign({}, General.base, General.formElemBase);
exports.flagsEnabledCheckbox = __assign({}, Mixins.scale(1.5));
exports.flagsEnabledLabel = __assign({}, General.base, { marginLeft: 0.5 * General.baseFontSize + "px" });
exports.numLivesInput = __assign({}, General.base, General.formElemBase, { width: 3 * General.baseFontSize + "px" });
exports.gameSeedInput = __assign({}, General.base, General.formElemBase);
exports.gameSeedGenerate = __assign({}, General.base, { marginLeft: 0.5 * General.baseFontSize + "px", height: 2.75 * General.baseFontSize + "px", cursor: 'pointer' });
exports.startGameButton = {
    base: __assign({}, General.base, General.buttonBase),
    ':hover': __assign({}, General.buttonHoverBase),
    ':active': __assign({}, General.buttonActiveBase),
    ':focus': __assign({}, General.buttonFocusBase),
};
exports.game = __assign({}, General.base, { position: 'relative', width: '100%', height: "calc(100% - " + menuHeight + "px)", overflow: 'auto' });
var headerHeight = 55;
exports.header = __assign({}, General.base, { position: 'relative', padding: 0.5 * General.baseFontSize + "px 0px", width: '100%', height: headerHeight + "px", overflow: 'auto' });
exports.headerTimer = __assign({}, General.base, General.headerDivBase);
exports.headerMines = __assign({}, General.base, General.headerDivBase);
exports.headerLives = __assign({}, General.base, General.headerDivBase);
exports.headerTimerImg = __assign({}, General.base, General.headerImgBase);
exports.headerMinesImg = __assign({}, General.base, General.headerImgBase);
exports.headerLivesImg = __assign({}, General.base, General.headerImgBase);
exports.notification = __assign({}, General.base, { position: 'absolute', marginTop: headerHeight + "px", width: '50%', left: '25%', top: '25%', padding: General_1.baseFontSize + "px", zIndex: 99, backgroundColor: 'rgba(0, 0, 0, 0.8)', color: 'white', fontWeight: 'bold', fontSize: 1.5 * General.baseFontSize + "px", textAlign: 'center' });
exports.notificationButton = {
    base: __assign({}, General.base, General.buttonBase),
    ':hover': __assign({}, General.buttonHoverBase),
    ':active': __assign({}, General.buttonActiveBase),
    ':focus': __assign({}, General.buttonFocusBase),
};
exports.minefield = __assign({}, General.base, { position: 'relative', width: '100%', height: "calc(100% - " + headerHeight + "px)", overflow: 'auto' });
exports.tile = {
    base: __assign({}, General.base, { float: 'left', border: "solid black " + 0.05 * General.baseFontSize + "px", backgroundColor: 'grey', cursor: 'pointer', textShadow: "-" + 0.02 * General.baseFontSize + "px\n      -" + 0.02 * General.baseFontSize + "px 0 #000,\n      " + 0.02 * General.baseFontSize + "px -" + 0.02 * General.baseFontSize + "px 0 #000,\n      -" + 0.02 * General.baseFontSize + "px " + 0.02 * General.baseFontSize + "px 0 #000,\n      " + 0.02 * General.baseFontSize + "px " + 0.02 * General.baseFontSize + "px 0 #000", fontWeight: 'bold', textAlign: 'center' }),
    lastInRow: {
        clear: 'left',
    },
    revealed: {
        backgroundColor: 'white',
    },
    mine: __assign({}, General.bgImgBase, { backgroundImage: 'url(/img/mine.png)' }),
    flag: __assign({}, General.bgImgBase, { backgroundImage: 'url(/img/flag.png)' }),
    incorrectFlag: __assign({}, General.bgImgBase, { backgroundImage: 'url(/img/incorrect-flag.png)' }),
    adjacentMines: {
        1: { color: 'rgb(0, 0, 0)' },
        2: { color: 'rgb(0, 0, 255)' },
        3: { color: 'rgb(0, 150, 255)' },
        4: { color: 'rgb(0, 255, 255)' },
        5: { color: 'rgb(255, 255, 150)' },
        6: { color: 'rgb(255, 255, 0)' },
        7: { color: 'rgb(255, 150, 0)' },
        8: { color: 'rgb(255, 0, 0)' },
    },
    edgeLengthAdjustments: [
        // ASC order of edgeLength
        { edgeLength: 15, styles: { fontSize: '10px' } },
        { edgeLength: 25, styles: { fontSize: '17px' } },
    ],
};
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/styles.js
// module id = 1
// module chunks = 0